import { ChangeEvent } from 'react'

export const handleChange = (
  event: ChangeEvent<HTMLInputElement>,
  key: string,
  setMethod: any
) => {
  const {
    target: { value }
  } = event

  const parsedValue = typeof value === 'string' ? value.toUpperCase() : value

  setMethod((prev: any) => ({ ...prev, [key]: parsedValue }))
}
